/* Id of the workspace item for a Stack project's list of a source item. */
export function getStackItemId(
  stackProjectId: number,
  sourceItemId: string
): string {
  return stackProjectId.toString() + '|' + sourceItemId;
}

/* Inverse of `getStackItemId`; undefined for ids of non-Stack items. */
export function parseStackItemId(
  id: string
): { stackProjectId: string; sourceItemId: string } | undefined {
  const [stackProjectId, ...rest] = id.split('|');
  if (rest.length === 0) return undefined;

  return { stackProjectId, sourceItemId: rest.join('|') };
}
